import { TableQueryType } from 'owa-mail-list-store';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import * as React from 'react';

export default {
    mailListItemClicked: {
        name: 'MailListItemClicked',
        customData: (
            evt: React.MouseEvent<unknown>,
            selectionSource: MailListItemSelectionSource,
            rowKey: string,
            tableViewId: string
        ): any[] => {
            const tableView = listViewStore.tableViews.get(tableViewId);
            const isSwitchGroupConversation =
                tableView.tableQuery.type == TableQueryType.Group &&
                tableView.selectedRowKeys.size == 1;
            return [
                selectionSource,
                tableView.tableQuery.listViewType,
                isSwitchGroupConversation,
                tableView.tableQuery.type,
            ];
        },
    },
};
